import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages';
import Login from './Login';
import Shared from './Shared';

function readStoredToken() {
  try {
    return JSON.parse(sessionStorage.getItem('token')) || null;
  } catch (error) {
    sessionStorage.removeItem('token');
    return null;
  }
}

function App() {
  const [token, setToken] = React.useState(readStoredToken);

  return (
    <Router>
      <Routes>
        <Route index element={<Home token={token} setToken={setToken} />} />
        <Route path="login" element={<Login token={token} setToken={setToken} />} />
        <Route path="shared/:username/:id" element={<Shared />} />
      </Routes>
    </Router>
  );
}

export default App;
